import { request } from '@umijs/max';

const statisticsService = {
  platformStatistics: async () => {
    const response = await request<API.Service.PlatformOverview>(
      '/moderate/stats',
      {
        method: 'GET',
      },
    );
    return response;
  },
};

export default statisticsService;
